import { Button, Col, Divider, Form, Input, Row, Table, Tag, Typography } from "antd";
import { FaArrowLeft, FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import Title from "antd/es/typography/Title";
import useEixo from "./useEixo";
import { getColumnSearchProps } from "../../utils";
import { EMetaStatus, IPlanoGovernoEixo, IPlanoGovernoEixoMeta } from "../../interfaces";
import { ModalFormMeta } from "./components/ModalFormMeta";
import { useCallback, useContext } from "react";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { inputCidade, inputDesc, inputObjetivo } from "./GridStyle";
import Loading from "../../../../components/Loading";

export default function Eixo() {

    const columnsMeta = [
        {
            title: "Ação a ser realizada",
            dataIndex: "descricao",
            key: "descricao",
            width: "40%",
            sorter: (a: any, b: any) => a.descricao.localeCompare(b.descricao),
            ...getColumnSearchProps("descricao"),
            showSorterTooltip: false,
        },
        {
            title: "Objetivo",
            dataIndex: "objetivo",
            key: "objetivo",
            width: "25%",
            sorter: (a: any, b: any) => a.objetivo.localeCompare(b.objetivo),
            ...getColumnSearchProps("objetivo"),
            showSorterTooltip: false,
            render: (val?: string | null) => {
                return (
                    <span>
                        {val && val?.length > 40 ?
                            val?.substring(0, 40) + '...' : val}
                    </span>
                );
            },
        },
        {
            title: "Conclusão (%)",
            dataIndex: "porcentagemConclusao",
            key: "porcentagemConclusao",
            width: "10%",
            sorter: (a: any, b: any) => a.porcentagemConclusao - b.porcentagemConclusao,
            showSorterTooltip: false,
            render: (val: number) => {

                let color = "yellow";

                if (val > 0 && val < 100) {
                    color = "blue"
                }

                if (val === 100) {
                    color = "green"
                }

                return (
                    <span>
                        <Tag color={color} key={val}>
                            {val}%
                        </Tag>
                    </span>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: "10%",
            sorter: (a: any, b: any) => a.status - b.status,
            showSorterTooltip: false,
            render: (val: string) => {

                const values: any = {
                    "Concluído": "green",
                    "Em reanálise": "orange",
                    "Pendente": "yellow",
                    "Em andamento": "blue",
                    "Cancelado": "red"
                }

                const color = values[val];

                return (
                    <span>
                        <Tag color={color} key={val}>
                            {val}
                        </Tag>
                    </span>
                );
            },
        },
        {
            title: "Ações",
            dataIndex: "uuid",
            key: "uuid",
            width: "10%",
            render: (uuid: string, record: IPlanoGovernoEixoMeta) => (
                <span>
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        size="small"
                        onClick={() => handleUpdateMeta(record.uuid)}
                    >
                        <FaEdit />
                    </Button>
                    <Divider type="vertical" />
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        danger
                        size="small"
                        onClick={() => {
                            onClickExcluirMeta(uuid);
                        }}
                    >
                        <FaTrash />
                    </Button>
                </span>
            ),
        },
    ];

    const { theme } = useContext(ThemeContext);

    const {
        metas,
        handleReturn,
        isLoading,
        refContagemDoFiltro,
        handleChangeModal,
        isModalOpen,
        handleUpdateMeta,
        handleCreateMeta,
        onClickExcluirMeta,
        metaUuidSelected,
        formEixo,
        refFormEixo,
        onClickSalvarEixo,
        onClickCancelEixo,
        isLoadingForm,
        eixo,
        isLoadingMunicipio,
        uuid,
    } = useEixo();

    return (
        <>
            <Loading
                loading={
                    isLoading ||
                    isLoadingForm ||
                    isLoadingMunicipio
                }
            >
                <Row style={{
                    marginTop: 10,
                    justifyContent: 'space-between'
                }}>
                    <Col
                        style={{
                            alignItems: "center",
                        }}
                    >
                        <Title level={3}>{eixo ? 'Atualizar ' : 'Cadastrar '} Eixo</Title>

                    </Col>
                    <Col
                        style={{
                            alignItems: "center",
                        }}
                    >
                        <Button
                            style={{
                                display: "flex",
                                flexDirection: 'row',
                                alignItems: "center",
                            }}
                            type="default"
                            onClick={() => handleReturn()}
                        >
                            <FaArrowLeft style={{ marginRight: 5 }} />
                            Voltar
                        </Button>
                    </Col>
                </Row>
                <div style={{
                    padding: 10,
                    marginTop: 10,
                    backgroundColor: theme === "dark" ? '#222' : '#f0f2f5',
                    borderRadius: 6,
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                }}>
                    <Form
                        form={formEixo}
                        ref={refFormEixo}
                        name="formEixo"
                        layout="vertical"
                        onFinishFailed={() => { }}
                    >
                        <Row gutter={16}>
                            <Col hidden>
                                <Form.Item
                                    name="uuid"
                                    label="uuid"
                                    rules={[
                                        {
                                            required: false,
                                            message: "Por favor preencha o id!",
                                        },
                                    ]}
                                >
                                    <Input placeholder="uuid" disabled />
                                </Form.Item>
                            </Col>
                            <Col {...inputCidade}>
                                <Form.Item
                                    name="idIbge"
                                    label="Cidade"
                                >
                                    <Input
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col {...inputDesc} >
                                <Form.Item
                                    name="descricao"
                                    label="Descrição"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor preencha a descrição do eixo!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        placeholder="Informe a descrição do eixo"
                                        style={{ maxHeight: 150, height: 20 }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col {...inputObjetivo}>
                                <Form.Item
                                    name="objetivo"
                                    label="Objetivo"
                                    rules={[
                                        {
                                            required: false,
                                            message:
                                                "Por favor preencha o objetivo!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        placeholder="Informe o objetivo do eixo"
                                        style={{ maxHeight: 150, height: 25 }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ textAlign: "end" }}>
                                <Button
                                    style={{ marginRight: 10 }}
                                    loading={isLoadingForm}
                                    onClick={uuid ? onClickCancelEixo : handleReturn }
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    type="primary"
                                    loading={isLoadingForm}
                                    onClick={() => onClickSalvarEixo()}
                                >
                                    Salvar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {
                    eixo && <Row style={{
                        marginTop: 50,
                        justifyContent: 'flex-start',
                        gap: 25
                    }}>
                        <Col
                            style={{
                                alignItems: "center",
                            }}
                        >
                            <Title level={3}>Metas</Title>

                        </Col>
                        <Col
                            style={{
                                alignItems: "center",
                            }}
                        >
                            <Button
                                style={{
                                    display: "flex",
                                    flexDirection: 'row',
                                    alignItems: "center",
                                    backgroundColor: "#2c7865"
                                }}
                                type="primary"
                                onClick={() => handleCreateMeta()}
                            >
                                <FaPlus style={{ marginRight: 5 }} />
                                Nova meta
                            </Button>
                        </Col>
                    </Row>
                }

                {
                    eixo && <div style={{ overflowX: "auto" }}>
                        <Table
                            columns={columnsMeta}
                            dataSource={metas}
                            footer={(registros) => {
                                return (
                                    <div
                                        style={{
                                            textAlign: "end",
                                        }}
                                    >
                                        <Typography>
                                            {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                            {`Mostrando: ${registros.length
                                                } de ${refContagemDoFiltro
                                                    .current.length === 0
                                                    ? metas.length
                                                    : refContagemDoFiltro
                                                        .current.length
                                                } num total de ${metas.length
                                                } `}
                                        </Typography>
                                    </div>
                                );
                            }}
                            pagination={{
                                locale: { items_per_page: "" },
                                showSizeChanger: true,
                                defaultPageSize: 100,
                                position: ["topRight", "bottomRight"],
                                pageSizeOptions: ["10", "20", "50", "100"],
                            }}
                            // rowSelection={rowSelection}
                            rowKey={Math.random}
                        //   loading={isLoading}
                        >

                        </Table>
                    </div>
                }
            </Loading >

            {eixo && <ModalFormMeta
                isModalOpen={isModalOpen}
                handleCancel={handleChangeModal}
                isLoading={isLoading}
                isEditar={metaUuidSelected ? true : false}
                metaUuid={metaUuidSelected}
                eixoUuid={eixo?.uuid}
            />
            }
        </>
    );
}
